import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { style: {"position":"fixed","top":"0","left":"0","width":"100%","z-index":"100","background":"white"} }
const _hoisted_2 = { style: {"height":"calc(100vh - 4rem)"} }
const _hoisted_3 = {
  key: 1,
  class: "textarea"
}
const _hoisted_4 = {
  class: "flex-n fac fjc",
  style: {"height":"100%"}
}

import {ref,onMounted,watch} from 'vue'

import answeringQuestionApi from "@/utils/Api/AnsweringQuestion";


export default /*@__PURE__*/_defineComponent({
  __name: 'funeralissues',
  setup(__props) {

const activeName = ref('');
const questionTitle=ref('')
onMounted(()=> {
  document.title = '丧葬问题答疑'
  // getDataList();
})
const loading=ref(false);
const list=ref([]);


const refreshing = ref(false);
const pageNo = ref(0);
const refresh = ref(false);
const finished = ref(false);

const onRefresh = () => {
  pageNo.value = 0;
  list.value = [];
  refreshing.value = false;
  // 清空列表数据
  finished.value = false;
  // 重新加载数据
  getDataList();
};
const getDataList = () => {
  pageNo.value++;
  loading.value=true;
console.log(pageNo.value,{questionTitle:questionTitle.value})
  answeringQuestionApi.pageList(pageNo.value,{questionTitle:questionTitle.value}).then(res => {
    list.value = list.value.concat(res.data.data || []);
    if (list.value.length >= res.data.dataCount) {
      finished.value = true;
    }
  }).finally(() => {
    loading.value=false;
    refresh.value = false;
  })
}
const loading2=ref(false);
const detail=ref('');
watch(()=>activeName.value,(newval)=>{
  console.log(newval)
  getData(newval);
})
const getData=(id:string)=>{
  loading2.value=true;
  answeringQuestionApi.detail(id).then(res=>{
    console.log(res.data.questionAnswer)
    detail.value=res.data.questionAnswer;
  }).catch(()=>{
    detail.value='';
  }).finally(() => {
    loading2.value=false;
  })
}



return (_ctx: any,_cache: any) => {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_collapse_item = _resolveComponent("van-collapse-item")!
  const _component_van_collapse = _resolveComponent("van-collapse")!
  const _component_van_overlay = _resolveComponent("van-overlay")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_search, {
        modelValue: questionTitle.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((questionTitle).value = $event)),
        "show-action": "",
        shape: "round",
        placeholder: "请输入关键词搜索问题"
      }, {
        action: _withCtx(() => [
          _createElementVNode("div", {
            style: {"color":"#1E77F8","font-size":"1.4rem"},
            onClick: getDataList
          }, "搜索")
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { style: {"height":"4rem"} }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_pull_refresh, {
        modelValue: refreshing.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((refreshing).value = $event)),
        onRefresh: onRefresh
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_list, {
            loading: loading.value,
            "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((loading).value = $event)),
            finished: finished.value,
            "finished-text": "没有更多了",
            onLoad: getDataList
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_collapse, {
                style: {"margin-top":"1rem"},
                modelValue: activeName.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeName).value = $event)),
                accordion: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
                    return (_openBlock(), _createBlock(_component_van_collapse_item, {
                      title: item.questionTitle,
                      name: item.id,
                      key: index
                    }, {
                      default: _withCtx(() => [
                        (loading2.value)
                          ? (_openBlock(), _createBlock(_component_van_loading, {
                              key: 0,
                              color: "#1989fa"
                            }))
                          : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(detail.value), 1))
                      ]),
                      _: 2
                    }, 1032, ["title", "name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_van_overlay, {
                show: loading.value,
                "z-index": "400"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_van_loading, { color: "#1989fa" })
                  ])
                ]),
                _: 1
              }, 8, ["show"])
            ]),
            _: 1
          }, 8, ["loading", "finished"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ], 64))
}
}

})